import { render, staticRenderFns } from "./AgregarProducto.vue?vue&type=template&id=0f4f8679"
import script from "./AgregarProducto.vue?vue&type=script&lang=js"
export * from "./AgregarProducto.vue?vue&type=script&lang=js"
import style0 from "./AgregarProducto.vue?vue&type=style&index=0&id=0f4f8679&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports